<template>
  <button @click="$emit('click')" class="no-style" :aria-label="ariaLabel" :id="button_id">
    <vx-card class="overlay-card overflow-hidden video-trigger-card">
      <template slot="no-body">
        <img :src="imageSrc" alt="" class="responsive" />
        <div class="card-overlay text-white flex flex-col justify-center items-center">
          <feather-icon icon="YoutubeIcon" svgClasses="h-40" />
        </div>
      </template>
    </vx-card>
  </button>
</template>

<script>
export default {
  props: {
    imageSrc: {
      type: String,
    },
    ariaLabel: {
      type: String,
      default: 'Watch video',
    },
    button_id: {
      type: String,
      default: null,
    },
  },
};
</script>

<style>
.video-trigger-card {
  cursor: pointer;
}
.h-40 {
  height: 60px;
  width: 60px;
}
</style>
